<!-- El formGroup se repite aquí porque formControlName no cruza el límite del componente hijo. -->
<div
  class="form-row"
  *ngIf="ctx.isEurDeclaredCashin"
  [formGroup]="ctx.declarationCashinForm"
>
  <div class="filter-column">
    <div class="form-item" *ngIf="ctx.transactionTypes.length">
      <label>Tipo de transacción</label>
      <div class="account-type-picker">
        <div
          *ngFor="let type of ctx.transactionTypes"
          class="accu-type"
          [class.selected]="
            ctx.declarationCashinForm.controls.transaction_type.value ===
            type.id
          "
          (click)="ctx.setDeclaredTransactionType(type.id)"
        >
          {{ type.id }}
        </div>
      </div>
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="eur_cashin_firstname">Nombres</label>
      <input
        id="eur_cashin_firstname"
        type="text"
        placeholder="Ingresa los nombres"
        formControlName="firstname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="eur_cashin_lastname">Apellidos</label>
      <input
        id="eur_cashin_lastname"
        type="text"
        placeholder="Ingresa los apellidos"
        formControlName="lastname"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="eur_cashin_account_number">IBAN</label>
      <input
        id="eur_cashin_account_number"
        type="tel"
        placeholder="Ingresa el IBAN"
        formControlName="account_number"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>
</div>
